export default __webpack_public_path__ + "static/media/palm-jumeriah.241e0105.webp";